import { useQuery } from '@tanstack/react-query';
import type { CouponDefinition } from '@/lib/api-admin';
import { adminFetch } from '@/lib/apiClient';

export const productCouponsQueryKey = (productId: string) =>
  ['admin', 'product-coupons', productId] as const;

export const useProductCouponsQuery = (productId: string | undefined) =>
  useQuery<CouponDefinition[]>({
    queryKey: productCouponsQueryKey(productId ?? ''),
    enabled: Boolean(productId),
    queryFn: async () => {
      const res = await adminFetch(`/api/admin/v1/coupons/by-product/${productId}`);
      if (!res.ok) throw new Error(`product-coupons fetch failed: ${res.status}`);
      const env = (await res.json()) as { data?: CouponDefinition[] };
      return Array.isArray(env.data) ? env.data : [];
    },
  });
